import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=d8520a78&scoped=true"
import script from "./SelectGoods.vue?vue&type=script&lang=js"
export * from "./SelectGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectGoods.vue?vue&type=style&index=0&id=d8520a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8520a78",
  null
  
)

export default component.exports